export const url = (...endpoints) => endpoints.join('/')

export const account = {
  $route: '/conta',

  get login() {
    return url(this.$route, 'login')
  },

  get logout() {
    return url(this.$route, 'logout')
  },

  get passwordRecover() {
    return url(this.$route, 'recuperar-senha')
  },

  get passwordLost() {
    return url(this.$route, 'alterar-senha')
  },

  get redirect() {
    return url(this.$route, 'redirect')
  },

  get signupCompanyWizard() {
    return url(this.$route, 'finalizar-cadastro-empresa')
  }
}

export const checkout = {
  $route: '/checkout',

  get index() {
    return this.$route
  },

  get pix() {
    return url(this.$route, 'pix')
  },

  get boleto() {
    return url(this.$route, 'boleto')
  },
}

export const pendingPayment = {
  $route: '/assinatura',

  get index() {
    return url(this.$route, 'pagar')
  },
  get payment() {
    return url(this.$route, 'pagamento')
  },
}

export const categoryDirectory = {
  $route: '/fornecedores',

  get index() {
    return url(this.$route, '')
  },

  stateList(serviceType) {
    return url(this.$route, serviceType)
  },

  serviceType(serviceType, slug) {
    return url(this.$route, serviceType, slug)
  },

  favoriteServiceType(serviceType, slug) {
    return url(this.$route, serviceType, slug, 'favoritos')
  }
}

export const categoryQuotation = {
  $route: '/orcamentos',

  get index() {
    return url(this.$route, '')
  },

  category(category) {
    return url(this.$route, category)
  },

  serviceType(category, serviceType) {
    return url(this.$route, category, serviceType)
  },
}

export const companyAccount = {
  $route: '/conta-empresa',

  get index() {
    return url(this.$route, 'dados-cadastrais')
  },
  get account() {
    return url(this.$route, 'dados-cadastrais')
  },
  get building() {
    return url(this.$route, 'estabelecimentos')
  },
  get review() {
    return url(this.$route, 'avaliacoes')
  },
  get userList() {
    return url(this.$route, 'usuarios')
  },
  get userAdd() {
    return url(this.$route, 'usuarios', 'adicionar')
  },
  get dashboard() {
    return url(this.$route, 'dashboard')
  },

  // Advertise
  get category() {
    return url(this.$route, 'meu-anuncio', 'especialidades-anunciadas')
  },
  get categoryEdit() {
    return url(this.$route, 'meu-anuncio', 'especialidades-anunciadas', 'associar-especialidades')
  },
  get location() {
    return url(this.$route, 'meu-anuncio', 'area-de-atendimento')
  },
  get editLocation() {
    return url(this.$route, 'meu-anuncio', 'area-de-atendimento', 'editar-regioes')
  },

  // Plans
  get creditCards() {
    return url(this.$route, 'meu-plano', 'planos-assinaturas', 'cartoes-de-credito')
  },
  get plans() {
    return url(this.$route, 'meu-plano', 'planos-assinaturas')
  },
  get plansSubscribe() {
    return url(this.$route, 'meu-plano', 'planos-assinaturas', 'assinar-plano')
  },
  get viewBalance() {
    return url(this.$route, 'meu-plano', 'saldo-e-extrato')
  },
  get recharge() {
    return url(this.$route, 'meu-plano', 'recarga-simples')
  },
  get rechargeSuccess() {
    return url(this.$route, 'meu-plano', 'recarga-simples', 'recarga-efetuada')
  },
  get rechargeBilling() {
    return url(this.$route, 'meu-plano', 'recarga-simples', 'aguardando-pagamento', 'boleto')
  },
  get rechargePix() {
    return url(this.$route, 'meu-plano', 'recarga-simples', 'aguardando-pagamento', 'pix')
  },
  get rechargeAutomatic() {
    return url(this.$route, 'meu-plano', 'recarga-automatica')
  },
  get editBilling() {
    return url(this.$route, 'meu-plano', 'dados-de-faturamento')
  },
}

export const companyProfile = {
  $route: '/fornecedor',

  index(slug) {
    return url(this.$route, slug)
  }
}

export const landing = {
  $route: '/',

  get index() {
    return this.$route
  },

  get about() {
    return url('', 'quem-somos')
  },

  get press() {
    return url('', 'imprensa')
  },

  get privacy() {
    return url('', 'politicas-de-privacidade')
  },

  get terms() {
    return url('', 'termos-de-uso')
  },

  get questions() {
    return url('', 'perguntas-frequentes')
  },

  get support() {
    return url('', 'central-de-ajuda')
  },

  get usage() {
    return url('', 'termos-de-uso')
  },

  get association() {
    return url('', 'termos-de-veiculacao')
  },

  get whatsApp() {
    // TODO: add this to a consts file
    return 'https://wa.me/5511940744624'
  },
}

export const landingSupplier = {
  $route: '/anuncie',

  get index() {
    return this.$route
  },

  indexCity(slug) {
    return url(this.$route, 'regiao', slug)
  },

  get signup() {
    return url(this.$route, 'cadastro-fornecedor')
  },

  get plans() {
    return url(this.$route, 'planos')
  },
}

export const migration = {
  $route: '/participacao',

  get index() {
    return this.$route
  },

  get acceptSindiconet() {
    return url(this.$route, 'sindiconet')
  },

  get activateAccount() {
    return url(this.$route, 'ativar-conta')
  },

  get migrationCompany() {
    return url(this.$route, 'finalizar-cadastro')
  },
}

export const quoteNegotiation = {
  $route: '/negociacoes',

  get index() {
    return url(this.$route, '')
  },

  details(identifier: string) {
    return url(this.$route, identifier)
  },

  get printRequest() {
    return url(this.$route, 'imprimir-solicitacao')
  }
}

export const quoteOpportunity = {
  $route: '/oportunidades',

  get index() {
    return url(this.$route, '')
  },

  details(identifier) {
    return url(this.$route, identifier)
  }
}

export const quoteRequest = {
  $route: '/solicitacoes',

  get index() {
    return url(this.$route, '')
  },

  get legacy() {
    return url(this.$route, 'legado')
  },

  details(identifier: string, category: string) {
    return `${this.$route}/${identifier}?category=${category}`
  },

  get printRequest() {
    return url(this.$route, 'imprimir-solicitacao')
  },

  get recentActivity() {
    return url(this.$route, 'atividades-recentes')
  },

  get lastQuotations() {
    return url(this.$route, 'ultimos-orcamentos')
  },

  get LastMessages() {
    return url(this.$route, 'ultimas-mensagens')
  },

  get evaluateSuppliers() {
    return url(this.$route, 'avaliar-fornecedores')
  },

  redoQuote(identifier: string) {
    return `${this.$route}/refazer-cotacao/${identifier}`
  },

  newQuotation(slug) {
    return url(this.$route, 'pedir-orcamento', slug)
  }
}

export const signup = {
  $route: '/cadastre-se',

  get newBuyer() {
    return url(this.$route, 'solicitante')
  },

  get newSupplier() {
    return url(this.$route, 'fornecedor')
  },
}

export const userAccount = {
  $route: '/minha-conta',

  get address() {
    return url(this.$route, 'enderecos')
  },
  get favorite() {
    return url(this.$route, 'fornecedores-favoritos')
  },
  get privacy() {
    return url(this.$route, 'privacidade')
  },
  get account() {
    return url(this.$route, 'dados-pessoais')
  },
  get changePassword() {
    return url(this.$route, 'alterar-senha')
  },

  get review() {
    return url(this.$route, 'avaliacoes')
  }
}

export const planUpgrade = {
  $route: '/upgrade-planos',

  get index() {
    return url(this.$route, '')
  },
}



export default {
  account,
  categoryDirectory,
  categoryQuotation,
  companyAccount,
  companyProfile,
  landing,
  quoteNegotiation,
  quoteOpportunity,
  quoteRequest,
  signup,
  userAccount,
  planUpgrade,
  checkout
}
